export default "__VITE_ASSET__wvHAyrZw__"